import { useAppDispatch } from '@/store/hooks';
import { getClients, getFirstPartyData, signUpDataAgreement } from '@/store/slices/firstPartyDataSlice';
import { Card } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DataAgreementModal from './DataAgreementModal';
import FileModal from './FileModals';
import FirstPartyDataGrid from './FirstPartyDataGrid';

const FirstPartyData = () => {
  const dispatch = useAppDispatch();
  const { filters, firstPartyDataRequestId, clients, firstPartyData } = useSelector(state => state.firstPartyData);

  // #region  MODALS
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [isAgreementModalOpen, setIsAgreementModalOpen] = useState(false);
  const handleCloseNewUserModal = () => {
    setIsFileModalOpen(false);
  };

  const handleCloseAgreementModal = () => {
    setIsAgreementModalOpen(false);
  };

  const handleConfirmAgreement = async () => {
    await dispatch(signUpDataAgreement()).unwrap();
    setIsAgreementModalOpen(false);
    setIsFileModalOpen(true);
  };

  const handleOpenModal = () => {
    setIsAgreementModalOpen(true);
  };
  // #endregion

  // #region DISPATCH
  useEffect(() => {
    dispatch(getFirstPartyData());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getClients());
  }, [dispatch]);
  // #endregion

  return (
    <div className='w-full p-[30px]'>
      <Card className='h-full'>
        <FirstPartyDataGrid
          handleOpenNewFileModal={handleOpenModal}
          data={firstPartyData}
          loading={!!firstPartyDataRequestId}
          filters={filters}
          clients={clients}
        />
        <FileModal open={isFileModalOpen} handleClose={handleCloseNewUserModal} />
        <DataAgreementModal
          open={isAgreementModalOpen}
          onClose={handleCloseAgreementModal}
          onConfirm={handleConfirmAgreement}
        />
      </Card>
    </div>
  );
};

export default FirstPartyData;
